import Vue from "vue";
import Vuex from "vuex";
import {
  router,
  mainvue
} from "../main"
Vue.use(Vuex);
const store = new Vuex.Store({
  state: {
    lamskpi_month: "",
    // 存储token
    Token: "",
    lamsUserInfo: "",
  },
  getters: {
    getToken(state) {
      if (state.Token == "" || state.Token == null) {
        state.Token = localStorage.getItem("Token");
      }

      return state.Token;
    },
    getlasmsUserInfo: (state) => () => {
      //获取数据
      if (state.lamsUserInfo == "" || state.lamsUserInfo == null) {
        state.lamsUserInfo = localStorage.getItem("lamsUserInfo");
      }
      if (!state.lamsUserInfo) {
        return null;
      }
      var Model_lasmsUserInfo = JSON.parse(state.lamsUserInfo);
      if (!Model_lasmsUserInfo) {
        return null;
      }


      if (!Model_lasmsUserInfo.out_time) {
        Model_lasmsUserInfo.out_time = 0;
      }
      // console.log(Date.parse(new Date()) - Model_lasmsUserInfo.out_time, "token 有效时间");
      // if (Date.parse(new Date()) - Model_lasmsUserInfo.out_time > public_parameter.token_out_timer) {
      //   //超时
      //   state.lamsUserInfo = "";
      //   localStorage.removeItem('lamsUserInfo')

      //   console.log("token超时，请重新登陆");
      //   // mainvue.$message.error("token超时，请重新登陆");
      //   router.push({
      //     path: "/"
      //   });
      //   return null;
      // }

      //更新数据包时间
      Model_lasmsUserInfo.out_time = Date.parse(new Date());
      state.lamsUserInfo = JSON.stringify(Model_lasmsUserInfo);
      localStorage.setItem("lamsUserInfo", state.lamsUserInfo);
      return state.lamsUserInfo;
    }
  },
  mutations: {
    lamskpi_month: function (state, val) {
      state.lamskpi_month = val;
    },
    // 修改token，并将token存入localStorage
    setToken(state, val) {
      state.Token = JSON.stringify(val);
      localStorage.setItem("Token", JSON.stringify(val));
    },
    delToken(state) {
      state.Token = "";
      state.Token_Time = 0,
        localStorage.removeItem('Token')
    },
    setlasmsUserInfo(state, val) {
      val.out_time = Date.parse(new Date());
      state.lamsUserInfo = JSON.stringify(val);
      localStorage.setItem("lamsUserInfo", JSON.stringify(val));
    },
    dellasmsUserInfo(state) {
      state.lamsUserInfo = "";
      localStorage.removeItem('lamsUserInfo')
    }
  },
  actions: {},
});

export default store;